import React from 'react';
import { GoogleMap, useJsApiLoader } from '@react-google-maps/api';
import LoginModal from '../../components/login-modal/auth-modal';

const containerStyle = {
  width: '100vw',
  height: '100vh',
};

const center = {
  lat: 28.5437,
  lng: 77.1880,
};

const LoginScreen: React.FC = () => {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: `${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`,
    // Must match the libraries used by every other useJsApiLoader call
    // (e.g. Dashboard.tsx) under the same loader id, or the shared Loader
    // throws "Loader must not be called again with different options."
    libraries: ['geometry'] as any,
  });

  const options = {
    disableDefaultUI: true,
    zoomControl: false,
    streetViewControl: false,
    mapTypeControl: false,
    fullscreenControl: false,
  };

  return isLoaded ? (
    <div>
      <GoogleMap
        options={options}
        mapContainerStyle={containerStyle}
        center={center}
        zoom={19}
      >
      </GoogleMap>
      <div className="company-logo">
        <img
          src="https://uploads-ssl.webflow.com/63001a1f3b1b4d42d0ae9396/66977ffc615ef2b8f6931569_Vector.png"
          alt="Logo"
          style={{ height: '60px', width: '200px', display: "block", position: "absolute", top: "10px", left: "10px" }}
        />
      </div>
      <LoginModal
        onHide={() => { }}
        onUsernameUpdate={() => { }}
      />
    </div>
  ) : (
    <div>Loading...</div>
  );
};

export default React.memo(LoginScreen);